/** Landscape print + fit width to one page; height allows many pages so long tables are not crushed. */
export const applyExcelLandscapePrintSetup = worksheet => {
  if (!worksheet) return;
  const ps = worksheet.pageSetup;
  ps.orientation = 'landscape';
  ps.paperSize = 9;
  ps.fitToPage = true;
  ps.fitToWidth = 1;
  ps.fitToHeight = 999;
};
